import { useState } from "react";
import StepperProps from "./stepper-props.interface";

const Stepper = ({ stepsRenderer }: StepperProps) => {
  const [stepIndex, setStepIndex] = useState(0);

  const increaseStep = () => setStepIndex((prevState) => prevState + 1);

  const finishStepsNavigation = () => setStepIndex(steps.length);

  const steps = stepsRenderer({ handleStepIncrease: increaseStep, handleStepsNavigationEnd: finishStepsNavigation });

  return stepIndex < steps.length? steps[stepIndex]: null;
};

export default Stepper;

// Example usage:
// const steps = [
//   {
//     renderedComponent: <div>One</div>,
//   },
//   {
//     renderedComponent: <div>two</div>,
//   },
//   {
//     renderedComponent: <div>Three</div>,
//   },
// ];
//   <Stepper
//     stepsRenderer={({ handleStepIncrease }) =>
//       steps.map((stepItem) => ({
//         ...stepItem,
//         controls: steps.indexOf(stepItem) !== (steps.length - 1) ? { nextStepActioner: handleStepIncrease } : null,
//       }))
//     }
//   />
